<div class="lb-page">
    <div class="lb-layout">
        <!-- LEFT PANEL -->
        <div class="lb-panel-left">
            <div class="lb-bg-img"></div>

            <div class="lb-brand">
                @if (logo) {
                    <img class="lb-brand-logo" src="/assets/img/lkLoginLogo.png" alt="Luka Koper" />
                }
            </div>

            <div class="lb-left-content">
                <div class="lb-hero-tagline">
                    AI Berthing
                    <span class="lb-hero-line"></span>
                </div>
            </div>
        </div>

        <!-- RIGHT PANEL -->
        <div class="lb-panel-right">
            <div class="lb-top-controls">
                @if (isDarkTheme()) {
                    <app-button tooltip="Light mode" variant="link" icon="faSolidSun" (clicked)="toggleTheme()" />
                } @else {
                    <app-button tooltip="Dark mode" variant="link" icon="faSolidMoon" (clicked)="toggleTheme()" />
                }
                <div placement="bottom-right" kendoTooltip title="{{ 'Change Language' | translate }}">
                    @if (currentLanguage()) {
                        <kendo-dropdownbutton
                            buttonClass="bg-card text-card-foreground border-none transition-none hover:bg-primary/20 bg-none"
                            [data]="languages">
                            <div class="flex items-center gap-1">
                                <svg
                                    class="mb-1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    style="width: 14px; height: 14px">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="2" y1="12" x2="22" y2="12" />
                                    <path
                                        d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                                </svg>
                                @if (showLanguageFlag) {
                                    <span class="p-0" [ngClass]="currentLanguage().iconClass"></span>
                                } @else {
                                    {{ currentLanguage().languageId | uppercase }}
                                }
                            </div>
                        </kendo-dropdownbutton>
                    }
                </div>
            </div>

            <div class="lb-card">
                <div class="lb-card-title">{{ 'Welcome back' | translate }}</div>
                <div class="lb-card-sub">{{ 'Please sign in to continue' | translate }}</div>

                <form novalidate (submit)="onSubmit()">
                    @if (errorMessage) {
                        <div class="lb-error">
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <span>{{ errorMessage | translate }}</span>
                        </div>
                    }

                    <div class="lb-form-group">
                        <label class="lb-label" for="lb-username">{{ 'Username' | translate }}</label>
                        <div class="lb-input-wrap">
                            <span class="lb-icon-left">
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                                    <circle cx="12" cy="7" r="4" />
                                </svg>
                            </span>
                            <input
                                class="lb-input"
                                type="text"
                                id="lb-username"
                                name="username"
                                autocomplete="username"
                                autofocus
                                [placeholder]="'Enter your username' | translate"
                                [class.lb-input-error]="!!errorMessage"
                                [(ngModel)]="username" />
                        </div>
                    </div>

                    <div class="lb-form-group">
                        <label class="lb-label" for="lb-password">{{ 'Password' | translate }}</label>
                        <div class="lb-input-wrap">
                            <span class="lb-icon-left">
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                    <path d="M7 11V7a5 5 0 0110 0v4" />
                                </svg>
                            </span>
                            <input
                                class="lb-input"
                                id="lb-password"
                                name="password"
                                autocomplete="current-password"
                                [type]="showPassword ? 'text' : 'password'"
                                [placeholder]="'Enter your password' | translate"
                                [class.lb-input-error]="!!errorMessage"
                                [(ngModel)]="password" />
                            <button
                                class="lb-icon-right"
                                type="button"
                                [attr.aria-label]="'Toggle password' | translate"
                                (click)="togglePassword()">
                                @if (showPassword) {
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path
                                            d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22" />
                                    </svg>
                                } @else {
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                }
                            </button>
                        </div>
                    </div>

                    <button class="lb-btn-login" type="submit" [class.lb-loading]="isBusy" [disabled]="isBusy">
                        <svg
                            class="lb-btn-lock"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0110 0v4" />
                        </svg>
                        <span class="lb-btn-text">{{ 'Sign In' | translate }}</span>
                        <div class="lb-spinner"></div>
                        <svg
                            class="lb-btn-arrow"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </button>
                </form>
            </div>

            <div class="lb-footer">
                @if (environment) {
                    <div class="lb-env-badge" [attr.style]="environmentColor">
                        {{ environment | translate }}
                    </div>
                }
                <span>{{ 'Version' | translate }} {{ version }}</span>
            </div>
        </div>
    </div>
</div>
